import React from 'react';
import LessonContainer from '../LessonContainer';

export default function HomeworkTabContent({
  currentWhiteboard, whiteboards, setWhiteboards,
  whiteboardContents, homeworkDataCache, setHomeworkDataCache,
  homeworkContainers, setHomeworkContainers,
  editorContents, setEditorContents,
  containerComments, setContainerComments,
  isStudent, lessonMode, remote,
  setMainEditor, setActiveEditorHandler, addEditorToMap,
  getHomeworkContainerContentChangeHandler,
  moveHomeworkContainerUp, moveHomeworkContainerDown,
  deleteHomeworkContainer, addHomeworkContainer,
  handleSendHomework, handleMarkReviewed, sendHomeworkSubmittingId,
  homeworkContentRef,
  expandedCommentKey, setExpandedCommentKey,
  commentTextFor, setCommentTextFor,
  commentTextDraft, setCommentTextDraft,
  commentRecordingFor, commentUploading, mediaRecorderRef,
  insertedRoundVideos, setInsertedRoundVideos,
  insertedRoundHoveredId, setInsertedRoundHoveredId,
  insertedRoundAudios, setInsertedRoundAudios,
  insertedRoundAudiosHoveredId, setInsertedRoundAudiosHoveredId,
  insertedRoundTexts, setInsertedRoundTexts,
  videoRoundDragRef, videoRoundDidDragRef,
  audioRoundDragRef, audioRoundDidDragRef,
  textRoundDragRef,
  audioRoundState, setAudioRoundState,
  audioRoundContainerKey, setAudioRoundContainerKey,
  audioRoundStreamRef, audioRoundChunksRef, audioRoundRecorderRef,
  setAudioRoundBlob, setAudioRoundUrl, setAudioRoundPosition,
  videoRoundState, setVideoRoundState,
  videoRoundContainerKey, setVideoRoundContainerKey,
  videoRoundStreamRef, videoRoundChunksRef, videoRoundRecorderRef, videoRoundVideoRef,
  setVideoRoundBlob, setVideoRoundUrl,
}) {
              // eslint-disable-next-line no-unused-vars
              const homeworkContent = whiteboardContents[`whiteboard-${currentWhiteboard.id}`] || '';
              
              // Получаем данные homework из кеша
              // Проверяем, обновлен ли ID на UUID
              let homeworkId = String(currentWhiteboard.id);
              let homeworkData = homeworkDataCache[homeworkId] || {};

              // Single-homework legacy fallback: if this lesson has exactly
              // ONE homework tab and its data is still keyed by the original
              // timestamp id in cache (loadHomeworkData hasn't yet renamed
              // it), pick up the lone UUID entry. With more than one homework
              // tab we can't safely guess which UUID belongs to which tab,
              // so we skip this — otherwise the second tab inherits the
              // first tab's data and every edit on one writes back into
              // both keys. (That was the actual bug behind "second homework
              // duplicates the first and edits mirror across them.")
              const homeworkTabs = whiteboards.filter(wb => wb.type === 'homework');
              const isLoneHomework = homeworkTabs.length === 1;
              if (!homeworkData.id && isLoneHomework && Object.keys(homeworkDataCache).length > 0) {
                const cacheKeys = Object.keys(homeworkDataCache);
                const uuidKey = cacheKeys.find(key => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(key));
                if (uuidKey) {
                  homeworkData = homeworkDataCache[uuidKey] || {};
                  homeworkId = uuidKey;

                  // Если нашли по UUID, но whiteboard ID еще timestamp, обновляем whiteboard
                  if (String(currentWhiteboard.id) !== uuidKey) {
                    setWhiteboards(prev => prev.map(wb =>
                      String(wb.id) === String(currentWhiteboard.id) && wb.type === 'homework'
                        ? { ...wb, id: uuidKey }
                        : wb
                    ));
                  }
                }
              }
              
              // Получаем контейнеры по правильному ID (UUID если есть)
              const currentHomeworkContainers = homeworkContainers[homeworkId] || homeworkContainers[currentWhiteboard.id] || [];
              
              // Проверяем, есть ли контейнеры в данных из кеша, но не в homeworkContainers
              const containersFromCache = homeworkData.containerContents || homeworkData.containers || [];
              if (containersFromCache.length > 0 && currentHomeworkContainers.length === 0) {
                // Попытка восстановить контейнеры из кеша
                setHomeworkContainers(prev => {
                  const newContainers = containersFromCache.map(cc => ({ id: cc.id, type: 'editor' }));
                  return {
                    ...prev,
                    [homeworkId]: newContainers
                  };
                });
                
                // Восстанавливаем содержимое контейнеров
                containersFromCache.forEach(containerContent => {
                  const containerId = String(containerContent.id);
                  const key = `homework-${homeworkId}-container-${containerId}`;
                  setEditorContents(prev => {
                    if (!prev[key]) {
                      return {
                        ...prev,
                        [key]: containerContent.content || ''
                      };
                    }
                    return prev;
                  });
                });
              }
      
      // console.log(`Rendering homework ${currentWhiteboard.id} with content:`, homeworkContent);
      
      return (
        <div ref={homeworkContentRef} style={{ position: 'relative' }}>
          {/* Заголовок homework */}
          <div style={{
            padding: '32px',
            marginBottom: '24px',
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid #f0f0f0'
          }}>
            {/* Заголовок секции */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '24px',
              paddingBottom: '16px',
              borderBottom: '1px solid #f5f5f5'
            }}>
              <div style={{
                width: '4px',
                height: '24px',
                backgroundColor: '#ee5a24',
                borderRadius: '2px',
                marginRight: '12px'
              }} />
              <h3 style={{
                margin: 0,
                fontSize: '18px',
                fontWeight: '600',
                color: '#333'
              }}>
                Homework Details
              </h3>
            </div>

            {/* Основные поля */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 200px',
              gap: '24px',
              marginBottom: '24px'
            }}>
              {/* Заголовок */}
              <div>
                <label style={{
                  fontSize: '13px',
                  color: '#888',
                  marginBottom: '6px',
                  fontWeight: '500',
                  display: 'block',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Title
                </label>
                <input
                  type="text"
                  placeholder="What's this homework about?"
                  value={homeworkData.title || ''}
                  readOnly={isStudent}
                  onChange={(e) => {
                    if (isStudent) return; // Студенты не могут редактировать
                    const updatedHomeworkData = {
                      ...homeworkData,
                      title: e.target.value
                    };
                    setHomeworkDataCache(prev => ({
                      ...prev,
                      [homeworkId]: updatedHomeworkData
                    }));
                  }}
                  style={{
                    width: '100%',
                    fontSize: '20px',
                    fontWeight: '600',
                    border: '1px solid #e8e8e8',
                    borderRadius: '12px',
                    outline: 'none',
                    backgroundColor: isStudent ? '#f5f5f5' : '#fafafa',
                    color: '#333',
                    padding: '16px 20px',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    cursor: isStudent ? 'default' : 'text'
                  }}
                  onFocus={(e) => {
                    if (isStudent) return;
                    e.target.style.borderColor = '#ee5a24';
                    e.target.style.backgroundColor = 'white';
                    e.target.style.boxShadow = '0 0 0 4px rgba(238,90,36,0.1)';
                  }}
                  onBlur={(e) => {
                    if (isStudent) return;
                    e.target.style.borderColor = '#e8e8e8';
                    e.target.style.backgroundColor = '#fafafa';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              {/* Дата сдачи */}
              <div>
                <label style={{
                  fontSize: '13px',
                  color: '#888',
                  marginBottom: '6px',
                  fontWeight: '500',
                  display: 'block',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Due Date
                </label>
                <input
                  type="date"
                  value={homeworkData.dueDate ? new Date(homeworkData.dueDate).toISOString().split('T')[0] : ''}
                  readOnly={isStudent}
                  onChange={(e) => {
                    if (isStudent) return; // Студенты не могут редактировать
                    const updatedHomeworkData = {
                      ...homeworkData,
                      dueDate: e.target.value ? new Date(e.target.value).toISOString() : null
                    };
                    setHomeworkDataCache(prev => ({
                      ...prev,
                      [homeworkId]: updatedHomeworkData
                    }));
                  }}
                  style={{
                    width: '100%',
                    fontSize: '16px',
                    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    border: '1px solid #e8e8e8',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    backgroundColor: isStudent ? '#f5f5f5' : '#fafafa',
                    color: '#333',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    cursor: isStudent ? 'default' : 'text'
                  }}
                  onFocus={(e) => {
                    if (isStudent) return;
                    e.target.style.borderColor = '#ee5a24';
                    e.target.style.backgroundColor = 'white';
                    e.target.style.boxShadow = '0 0 0 4px rgba(238,90,36,0.1)';
                  }}
                  onBlur={(e) => {
                    if (isStudent) return;
                    e.target.style.borderColor = '#e8e8e8';
                    e.target.style.backgroundColor = '#fafafa';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>
            </div>

            {/* Описание */}
            <div>
              <label style={{
                fontSize: '13px',
                color: '#888',
                marginBottom: '6px',
                fontWeight: '500',
                display: 'block',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Description
              </label>
              <textarea
                placeholder="Provide clear instructions for students..."
                value={homeworkData.description || ''}
                readOnly={isStudent}
                onChange={(e) => {
                  if (isStudent) return; // Студенты не могут редактировать
                  const updatedHomeworkData = {
                    ...homeworkData,
                    description: e.target.value
                  };
                  setHomeworkDataCache(prev => ({
                    ...prev,
                    [currentWhiteboard.id]: updatedHomeworkData
                  }));
                }}
                style={{
                  width: '100%',
                  fontSize: '16px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '12px',
                  outline: 'none',
                  backgroundColor: isStudent ? '#f5f5f5' : '#fafafa',
                  color: '#333',
                  padding: '16px 20px',
                  resize: 'vertical',
                  minHeight: '100px',
                  fontFamily: 'inherit',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box',
                  lineHeight: '1.6',
                  cursor: isStudent ? 'default' : 'text'
                }}
                onFocus={(e) => {
                  if (isStudent) return;
                  e.target.style.borderColor = '#ee5a24';
                  e.target.style.backgroundColor = 'white';
                  e.target.style.boxShadow = '0 0 0 4px rgba(238,90,36,0.1)';
                }}
                onBlur={(e) => {
                  if (isStudent) return;
                  e.target.style.borderColor = '#e8e8e8';
                  e.target.style.backgroundColor = '#fafafa';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          </div>
          
  
          {currentHomeworkContainers.map((container, index) => {
            const containerContent = editorContents[`homework-${homeworkId}-container-${container.id}`] || '';
  
            return (
              <div 
                key={container.id}
                style={{ position: 'relative' }}
              >
                <div style={{ position: 'relative' }}>
                  <LessonContainer 
                    id={`homework-${homeworkId}-${container.id}`} 
                    setMainEditor={setMainEditor} 
                    setActiveEditorId={setActiveEditorHandler}
                    addEditorToMap={(editorId, editor) => {
                      addEditorToMap(editorId, editor);
                    }}
                    initialContent={containerContent}
                    onContentChange={getHomeworkContainerContentChangeHandler(homeworkId, container.id)}
                    isStudent={isStudent}
                    lessonMode={lessonMode}
                    // Mirrors the other side's live typing in this homework
                    // container, same as the main lesson container. This was
                    // disabled for the student side for a while: several
                    // OTHER bugs (now fixed) let stale content leak into the
                    // teacher's own editorContents/homeworkDataCache for this
                    // exact key — the lesson document's snapshot restore on
                    // load, and the teacher's metadata autosave firing from
                    // merely opening the homework — which then got published
                    // here and force-applied over the student's real answer.
                    // Now that those sources are fixed, this is safe again:
                    // TextEditor's applyLiveContent only ever force-applies
                    // remote content when the local editor is unfocused AND
                    // no local edit has happened since the remote snapshot
                    // arrived, so it can't clobber active typing on either
                    // side.
                    liveContent={isStudent
                      ? (remote?.editorContents?.[`homework-${homeworkId}-container-${container.id}`] || null)
                      : (remote?.studentEditorContents?.[`homework-${homeworkId}-container-${container.id}`] || null)}
                  />
                  {/* Кнопки перемещения */}
                  <button
                    onClick={() => moveHomeworkContainerUp(homeworkId, container.id)}
                    onMouseEnter={(e) => {
                      const svg = e.target.querySelector('svg');
                      if (svg) svg.style.fill = '#ee5a24';
                    }}
                    onMouseLeave={(e) => {
                      const svg = e.target.querySelector('svg');
                      if (svg) svg.style.fill = '#ccc';
                    }}
                    title="Move container up"
                    style={{
                      position: 'absolute',
                      top: 12,
                      right: 40,
                      width: 25,
                      height: 25,
                      background: 'transparent',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      zIndex: 100,
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                      <path d="m505.646 388.491c-4.237 4.237-9.788 6.356-15.341 6.356s-11.104-2.119-15.341-6.356l-218.964-218.964-218.964 218.964c-8.475 8.475-22.208 8.475-30.682 0-8.472-8.47-8.472-22.208 0-30.678l234.305-234.307c8.475-8.47 22.208-8.47 30.682 0l234.305 234.307c8.472 8.47 8.472 22.207 0 30.678z"/>
                    </svg>
                  </button>
                  <button
                    onClick={() => moveHomeworkContainerDown(homeworkId, container.id)}
                    onMouseEnter={(e) => {
                      const svg = e.target.querySelector('svg');
                      if (svg) svg.style.fill = '#ee5a24';
                    }}
                    onMouseLeave={(e) => {
                      const svg = e.target.querySelector('svg');
                      if (svg) svg.style.fill = '#ccc';
                    }}
                    title="Move container down"
                    style={{
                      position: 'absolute',
                      top: 12,
                      right: 67,
                      width: 25,
                      height: 25,
                      background: 'transparent',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      zIndex: 100,
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                      <path d="m505.646 154.188-234.305 234.303c-4.237 4.237-9.788 6.356-15.341 6.356s-11.104-2.119-15.341-6.356l-234.305-234.303c-8.472-8.472-8.472-22.21 0-30.682 8.475-8.47 22.208-8.47 30.682 0l218.964 218.964 218.964-218.964c8.475-8.47 22.208-8.47 30.682 0 8.472 8.473 8.472 22.21 0 30.682z"/>
                    </svg>
                  </button>
                  <button
                    onClick={() => deleteHomeworkContainer(homeworkId, container.id)}
                    onMouseEnter={(e) => {
                      const svg = e.target.querySelector('svg');
                      if (svg) svg.style.fill = '#ee5a24';
                    }}
                    onMouseLeave={(e) => {
                      const svg = e.target.querySelector('svg');
                      if (svg) svg.style.fill = '#ccc';
                    }}
                    title="Delete container"
                    style={{
                      position: 'absolute',
                      top: 12,
                      right: 12,
                      width: 25,
                      height: 25,
                      background: 'transparent',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      zIndex: 100,
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                    </svg>
                  </button>
                  {!isStudent && (() => {
                    const containerKey = `homework-${homeworkId}-container-${container.id}`;
                    const isExpanded = expandedCommentKey === containerKey;
                    const showTextInput = commentTextFor === containerKey;
                    const isRecording = commentRecordingFor?.key === containerKey && commentRecordingFor?.type;
                    // Square sub-button (Text/Audio/Video). The label sits below
                    // the button via `.comment-pill-card`.
                    const subBtn = {
                      flexShrink: 0, width: 44, height: 44, border: 'none', borderRadius: 12,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      cursor: 'pointer', color: '#fff',
                      transition: 'transform 140ms ease, box-shadow 140ms ease, filter 140ms ease',
                    };
                    const isAudioRecordingHere = audioRoundState === 'recording' && audioRoundContainerKey === containerKey;
                    const isVideoRecordingHere = videoRoundState === 'recording' && videoRoundContainerKey === containerKey;
                    return (
                      <div style={{ position: 'absolute', bottom: 12, right: 12, display: 'flex', flexDirection: 'column-reverse', alignItems: 'flex-end', gap: 10, zIndex: 100 }}>
                        {/* Recording dock — appears ABOVE the pill while
                            this container is recording audio or video. Compact
                            inline indicator instead of the old floating
                            viewport-bottom-right circle. */}
                        {isVideoRecordingHere && (
                          <div style={{
                            position: 'absolute', bottom: '100%', right: 0, marginBottom: 12,
                            display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 8,
                            padding: 10,
                            background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
                            borderRadius: 16,
                            boxShadow: '0 12px 32px rgba(15, 23, 42, 0.36), 0 2px 6px rgba(15, 23, 42, 0.2)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            zIndex: 102,
                          }}>
                            <div style={{ position: 'relative', width: 220, height: 165, borderRadius: 12, overflow: 'hidden', background: '#000' }}>
                              <video
                                ref={videoRoundVideoRef}
                                autoPlay muted playsInline
                                style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scaleX(-1)' }}
                              />
                              <div style={{
                                position: 'absolute', top: 8, left: 8,
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '4px 10px',
                                background: 'rgba(0, 0, 0, 0.55)',
                                backdropFilter: 'blur(4px)',
                                borderRadius: 999,
                                color: '#fff',
                                fontSize: 11,
                                fontWeight: 600,
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase',
                              }}>
                                <span style={{
                                  width: 8, height: 8, borderRadius: '50%',
                                  background: '#ef4444',
                                  animation: 'commentRecPulse 1.2s infinite',
                                }} />
                                Rec
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={() => { if (videoRoundRecorderRef.current?.state === 'recording') videoRoundRecorderRef.current.stop(); }}
                              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                              style={{
                                padding: '8px 14px',
                                background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                                color: '#fff', border: 'none', borderRadius: 999,
                                cursor: 'pointer', fontSize: 13, fontWeight: 600,
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                                boxShadow: '0 4px 12px rgba(220, 38, 38, 0.4)',
                                transition: 'transform 140ms ease, filter 140ms ease',
                              }}
                            >
                              <span style={{ fontSize: 10, lineHeight: 1 }}>■</span> Stop recording
                            </button>
                          </div>
                        )}
                        {isAudioRecordingHere && (
                          <div style={{
                            position: 'absolute', bottom: '100%', right: 0, marginBottom: 12,
                            display: 'inline-flex', alignItems: 'center', gap: 10,
                            padding: '10px 14px',
                            background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
                            color: '#fff',
                            borderRadius: 999,
                            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.32), 0 1px 3px rgba(15, 23, 42, 0.18)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            whiteSpace: 'nowrap',
                            zIndex: 102,
                          }}>
                            <span style={{
                              width: 10, height: 10, borderRadius: '50%',
                              background: '#ef4444',
                              boxShadow: '0 0 0 0 rgba(239, 68, 68, 0.7)',
                              animation: 'commentRecPulse 1.2s infinite',
                            }} />
                            <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.02em' }}>
                              Recording audio…
                            </span>
                            <button
                              type="button"
                              onClick={() => { if (audioRoundRecorderRef.current?.state === 'recording') audioRoundRecorderRef.current.stop(); }}
                              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                              style={{
                                marginLeft: 6,
                                padding: '5px 12px',
                                background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                                color: '#fff', border: 'none', borderRadius: 999,
                                cursor: 'pointer', fontSize: 12, fontWeight: 600,
                                display: 'inline-flex', alignItems: 'center', gap: 5,
                                boxShadow: '0 3px 10px rgba(220, 38, 38, 0.36)',
                                transition: 'transform 140ms ease, filter 140ms ease',
                              }}
                            >
                              <span style={{ fontSize: 9, lineHeight: 1 }}>■</span> Stop
                            </button>
                          </div>
                        )}
                        {/* Main pill — icon + label, expands to "× Close" when open */}
                        <button
                          onClick={() => { setExpandedCommentKey(isExpanded ? null : containerKey); setCommentTextFor(null); setCommentTextDraft(''); }}
                          onMouseEnter={(e) => { if (!isExpanded) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.filter = 'brightness(1.06)'; } }}
                          onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                          style={{
                            display: 'inline-flex', alignItems: 'center', gap: 8,
                            padding: '8px 16px', borderRadius: 999, border: 'none',
                            cursor: 'pointer', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
                            transition: 'transform 140ms ease, box-shadow 140ms ease, filter 140ms ease, background 200ms ease',
                            background: isExpanded
                              ? 'rgba(148, 163, 184, 0.16)'
                              : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                            color: isExpanded ? '#475569' : '#fff',
                            boxShadow: isExpanded
                              ? 'none'
                              : '0 6px 16px rgba(99, 102, 241, 0.32), 0 1px 3px rgba(99, 102, 241, 0.18)',
                          }}
                        >
                          {isExpanded ? (
                            <>
                              <svg width="12" height="12" viewBox="0 0 14 14" fill="currentColor"><path d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"/></svg>
                              <span>Close</span>
                            </>
                          ) : (
                            <>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8c0 3.866-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                              </svg>
                              <span>Add comment</span>
                            </>
                          )}
                        </button>
                        <div className={`comment-expand-wrapper ${isExpanded ? 'reveal' : ''}`}>
                            <div className="comment-pill-card">
                            <button
                              className="comment-expand-icon"
                              onClick={() => { setCommentTextFor(containerKey); setCommentTextDraft(''); }}
                              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                              style={{
                                ...subBtn,
                                background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
                                boxShadow: '0 4px 12px rgba(79, 70, 229, 0.28)',
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"/></svg>
                            </button>
                            <span className="comment-pill-label">Text</span>
                            </div>
                            <div className="comment-pill-card">
                            <button className="comment-expand-icon" onClick={async () => {
                              if (audioRoundState === 'recording' || audioRoundState === 'preview') return;
                              try {
                                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                                audioRoundStreamRef.current = stream;
                                audioRoundChunksRef.current = [];
                                const mime = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4';
                                const recorder = new MediaRecorder(stream, { mimeType: mime });
                                audioRoundRecorderRef.current = recorder;
                                recorder.ondataavailable = (e) => { if (e.data.size) audioRoundChunksRef.current.push(e.data); };
                                recorder.onstop = () => {
                                  if (audioRoundStreamRef.current) { audioRoundStreamRef.current.getTracks().forEach(t => t.stop()); audioRoundStreamRef.current = null; }
                                  const blob = new Blob(audioRoundChunksRef.current, { type: mime });
                                  audioRoundChunksRef.current = [];
                                  const url = URL.createObjectURL(blob);
                                  setAudioRoundBlob(blob);
                                  setAudioRoundUrl(url);
                                  setAudioRoundState('preview');
                                  setAudioRoundContainerKey(containerKey);
                                  setAudioRoundPosition({ x: typeof window !== 'undefined' ? window.innerWidth - 250 : 100, y: typeof window !== 'undefined' ? window.innerHeight - 280 : 100 });
                                };
                                recorder.start();
                                setAudioRoundState('recording');
                                setAudioRoundContainerKey(containerKey);
                              } catch (err) { console.error('Microphone access failed:', err); }
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                            style={{
                              ...subBtn,
                              background: (audioRoundState === 'recording' && audioRoundContainerKey === containerKey)
                                ? 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)'
                                : 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                              boxShadow: (audioRoundState === 'recording' && audioRoundContainerKey === containerKey)
                                ? '0 4px 12px rgba(220, 38, 38, 0.32)'
                                : '0 4px 12px rgba(16, 185, 129, 0.28)',
                            }}>
                              {(audioRoundState === 'recording' && audioRoundContainerKey === containerKey) ? (
                                <span style={{ fontSize: 12, lineHeight: 1 }}>●</span>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z"/><path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"/></svg>
                              )}
                            </button>
                            <span className="comment-pill-label">
                              {(audioRoundState === 'recording' && audioRoundContainerKey === containerKey) ? 'Rec…' : 'Audio'}
                            </span>
                            </div>
                            <div className="comment-pill-card">
                            <button className="comment-expand-icon" onClick={async () => {
                              if (videoRoundState === 'recording' || videoRoundState === 'preview') return;
                              try {
                                const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
                                videoRoundStreamRef.current = stream;
                                videoRoundChunksRef.current = [];
                                const mime = MediaRecorder.isTypeSupported('video/webm') ? 'video/webm' : 'video/mp4';
                                const recorder = new MediaRecorder(stream, { mimeType: mime });
                                videoRoundRecorderRef.current = recorder;
                                recorder.ondataavailable = (e) => { if (e.data.size) videoRoundChunksRef.current.push(e.data); };
                                recorder.onstop = () => {
                                  if (videoRoundStreamRef.current) { videoRoundStreamRef.current.getTracks().forEach(t => t.stop()); videoRoundStreamRef.current = null; }
                                  const blob = new Blob(videoRoundChunksRef.current, { type: mime });
                                  videoRoundChunksRef.current = [];
                                  const url = URL.createObjectURL(blob);
                                  setVideoRoundBlob(blob);
                                  setVideoRoundUrl(url);
                                  setVideoRoundState('preview');
                                };
                                recorder.start();
                                setVideoRoundContainerKey(containerKey);
                                setVideoRoundState('recording');
                              } catch (err) { console.error('Camera access failed:', err); }
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                            style={{
                              ...subBtn,
                              background: (videoRoundState === 'recording' && videoRoundContainerKey === containerKey)
                                ? 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)'
                                : 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)',
                              boxShadow: (videoRoundState === 'recording' && videoRoundContainerKey === containerKey)
                                ? '0 4px 12px rgba(220, 38, 38, 0.32)'
                                : '0 4px 12px rgba(139, 92, 246, 0.28)',
                            }}>
                              {videoRoundState === 'recording' && videoRoundContainerKey === containerKey ? (
                                <span style={{ fontSize: 12, lineHeight: 1 }}>●</span>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2z"/></svg>
                              )}
                            </button>
                            <span className="comment-pill-label">
                              {(videoRoundState === 'recording' && videoRoundContainerKey === containerKey) ? 'Rec…' : 'Video'}
                            </span>
                            </div>
                        </div>
                        {showTextInput && (
                          <div style={{
                            position: 'absolute', bottom: '100%', right: 0, marginBottom: 12,
                            background: '#fff',
                            border: '1px solid #e5e7eb',
                            borderRadius: 12,
                            padding: 12,
                            boxShadow: '0 20px 40px rgba(15, 23, 42, 0.18), 0 4px 12px rgba(15, 23, 42, 0.08)',
                            minWidth: 260,
                            zIndex: 101,
                            animation: 'commentPanelFade 180ms cubic-bezier(0.16, 1, 0.3, 1)',
                          }}>
                            <textarea
                              value={commentTextDraft}
                              onChange={e => setCommentTextDraft(e.target.value)}
                              placeholder="Type your comment…"
                              style={{
                                width: '100%', minHeight: 72, padding: '10px 12px',
                                borderRadius: 8, border: '1.5px solid #e5e7eb',
                                fontSize: 13, lineHeight: 1.5, color: '#1e293b',
                                resize: 'vertical', boxSizing: 'border-box',
                                fontFamily: 'inherit',
                                transition: 'border-color 120ms ease, box-shadow 120ms ease',
                                outline: 'none',
                              }}
                              onFocus={(e) => { e.currentTarget.style.borderColor = '#6366f1'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.15)'; }}
                              onBlur={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.boxShadow = 'none'; }}
                              autoFocus
                            />
                            <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'flex-end' }}>
                              <button
                                type="button"
                                onClick={() => { setCommentTextFor(null); setCommentTextDraft(''); }}
                                style={{
                                  padding: '7px 14px',
                                  background: '#f1f5f9',
                                  color: '#475569',
                                  border: 'none',
                                  borderRadius: 8,
                                  cursor: 'pointer',
                                  fontSize: 13,
                                  fontWeight: 500,
                                  transition: 'background 120ms ease',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = '#e2e8f0'}
                                onMouseLeave={(e) => e.currentTarget.style.background = '#f1f5f9'}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  const body = (commentTextDraft || '').trim();
                                  if (!body) return;
                                  // ONE-STEP insert: skip the floating preview and Insert button.
                                  // Position is computed relative to homeworkContentRef so every
                                  // new comment lands in a predictable place, stacked vertically
                                  // by count for this container so they don't overlap.
                                  const existingCount = insertedRoundTexts.filter(t => t.containerKey === containerKey).length;
                                  const pos = { x: 24, y: 24 + existingCount * 80 };
                                  setInsertedRoundTexts(prev => [...prev, {
                                    id: `rt-${Date.now()}-${Math.random().toString(36).slice(2)}`,
                                    containerKey,
                                    body,
                                    position: pos,
                                  }]);
                                  setContainerComments(prev => ({
                                    ...prev,
                                    [containerKey]: [...(prev[containerKey] || []), { type: 'text', body, createdAt: new Date().toISOString() }],
                                  }));
                                  setExpandedCommentKey(null);
                                  setCommentTextFor(null);
                                  setCommentTextDraft('');
                                }}
                                style={{
                                  padding: '7px 18px',
                                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 8,
                                  cursor: 'pointer',
                                  fontSize: 13,
                                  fontWeight: 600,
                                  boxShadow: '0 3px 10px rgba(99, 102, 241, 0.28)',
                                  transition: 'transform 140ms ease, filter 140ms ease',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
                              >
                                Add comment
                              </button>
                            </div>
                          </div>
                        )}
                        {(isRecording || commentUploading) && (
                          <div style={{ position: 'absolute', bottom: '100%', right: 0, marginBottom: 8, background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, padding: '8px 12px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', fontSize: 12, zIndex: 101 }}>
                            {commentUploading ? 'Uploading…' : `Recording ${commentRecordingFor?.type}…`}
                            {isRecording && !commentUploading && (
                              <button type="button" onClick={() => { if (mediaRecorderRef.current?.state === 'recording') mediaRecorderRef.current.stop(); }} style={{ marginLeft: 8, padding: '2px 8px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Stop</button>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
                {/* Comments list below container */}
                {(() => {
                  const containerKey = `homework-${homeworkId}-container-${container.id}`;
                  const comments = containerComments[containerKey] || [];
                  const listComments = comments.filter(c => c.type !== 'video' && c.type !== 'audio' && c.type !== 'text');
                  if (listComments.length === 0) return null;
                  return (
                    <div style={{ marginTop: 8, marginLeft: 8, padding: '8px 12px', background: '#f8f9fa', borderRadius: 8, borderLeft: '3px solid #ee5a24' }}>
                      <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Teacher comments</div>
                      {listComments.map((c, i) => (
                        <div key={i} style={{ marginBottom: 8 }}>
                          {c.type === 'text' && <p style={{ margin: 0, fontSize: 14, whiteSpace: 'pre-wrap' }}>{c.body}</p>}
                        </div>
                      ))}
                    </div>
                  );
                })()}
              {/* Вставленные круглые видео/аудио/текст — только для этого контейнера */}
              {insertedRoundVideos.filter(it => it.containerKey === `homework-${homeworkId}-container-${container.id}`).map((item) => (
                <div key={item.id} style={{ position: 'absolute', left: item.position.x, top: item.position.y, zIndex: 10002, display: 'flex', alignItems: 'flex-start', gap: 0 }}>
                  <div style={{ position: 'relative', width: 127, height: 127, transform: (insertedRoundHoveredId === item.id || item.playing) ? 'scale(200/120)' : 'scale(1)', transformOrigin: 'center center', transition: 'transform 0.2s ease' }} onMouseEnter={() => setInsertedRoundHoveredId(item.id)} onMouseLeave={() => setInsertedRoundHoveredId(null)}>
                    <svg width={127} height={127} style={{
                      position: 'absolute', left: 0, top: 0,
                      transform: 'rotate(-90deg)',
                      filter: item.playing
                        ? 'drop-shadow(0 0 8px rgba(139, 92, 246, 0.55))'
                        : 'drop-shadow(0 0 3px rgba(139, 92, 246, 0.25))',
                      transition: 'filter 240ms ease',
                    }}>
                      <defs>
                        <linearGradient id={`vrg-${item.id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#6366f1" />
                          <stop offset="50%" stopColor="#8b5cf6" />
                          <stop offset="100%" stopColor="#d946ef" />
                        </linearGradient>
                      </defs>
                      <circle cx={63.5} cy={63.5} r={60} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth={3} />
                      <circle
                        cx={63.5} cy={63.5} r={60}
                        fill="none"
                        stroke={`url(#vrg-${item.id})`}
                        strokeWidth={5}
                        strokeLinecap="round"
                        strokeDasharray={2 * Math.PI * 60}
                        strokeDashoffset={2 * Math.PI * 60 * (1 - (item.duration > 0 ? item.currentTime / item.duration : 0))}
                      />
                    </svg>
                    <div style={{ position: 'absolute', left: 3.5, top: 3.5, width: 120, height: 120, borderRadius: '50%', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', background: '#000', cursor: 'grab' }} onMouseDown={(e) => { if (e.target.closest('button')) return; e.preventDefault(); videoRoundDidDragRef.current = false; videoRoundDragRef.current = { isDragging: true, startX: e.clientX, startY: e.clientY, startLeft: item.position.x, startTop: item.position.y, insertedId: item.id }; }} onTouchStart={(e) => { if (e.target.closest('button')) return; const t = e.touches[0]; videoRoundDidDragRef.current = false; videoRoundDragRef.current = { isDragging: true, startX: t.clientX, startY: t.clientY, startLeft: item.position.x, startTop: item.position.y, insertedId: item.id }; }}>
                      <video data-round-id={item.id} src={item.videoUrl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onLoadedMetadata={(e) => { const v = e.target; setInsertedRoundVideos(prev => prev.map(it => it.id === item.id ? { ...it, duration: v.duration || 1 } : it)); }} onPlay={() => setInsertedRoundVideos(prev => prev.map(it => it.id === item.id ? { ...it, playing: true } : it))} onPause={() => setInsertedRoundVideos(prev => prev.map(it => it.id === item.id ? { ...it, playing: false } : it))} onEnded={() => setInsertedRoundVideos(prev => prev.map(it => it.id === item.id ? { ...it, playing: false, currentTime: 0 } : it))} />
                      <div role="button" tabIndex={0} onClick={(e) => { e.stopPropagation(); if (videoRoundDidDragRef.current) return; const vid = e.currentTarget.parentElement.querySelector('video'); if (vid) { if (vid.paused) vid.play(); else vid.pause(); } }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); const vid = e.currentTarget.parentElement.querySelector('video'); if (vid) { if (vid.paused) vid.play(); else vid.pause(); } } }} onMouseEnter={() => setInsertedRoundVideos(prev => prev.map(it => it.id === item.id ? { ...it, overlayHovered: true } : it))} onMouseLeave={() => setInsertedRoundVideos(prev => prev.map(it => it.id === item.id ? { ...it, overlayHovered: false } : it))} style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: !item.playing ? 'rgba(0,0,0,0.3)' : (item.overlayHovered ? 'rgba(0,0,0,0.2)' : 'transparent') }}>
                        {!item.playing && <svg width="40" height="40" viewBox="0 0 24 24" fill="rgba(255,255,255,0.95)"><path d="M8 5v14l11-7z" /></svg>}
                        {item.playing && item.overlayHovered && <svg width="28" height="28" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" /></svg>}
                      </div>
                    </div>
                  </div>
                  <button type="button" onClick={() => setInsertedRoundVideos(prev => prev.filter(it => it.id !== item.id))} title="Remove" style={{ marginLeft: -12, marginTop: -4, width: 22, height: 22, borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,0.35)', color: 'rgba(255,255,255,0.85)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, opacity: 0.8 }} aria-label="Remove">
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="currentColor"><path d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" /></svg>
                  </button>
                </div>
              ))}
              {insertedRoundAudios.filter(it => it.containerKey === `homework-${homeworkId}-container-${container.id}`).map((item) => (
                <div key={item.id} style={{ position: 'absolute', left: item.position.x, top: item.position.y, zIndex: 10002, display: 'flex', alignItems: 'flex-start', gap: 0 }}>
                  <div style={{ position: 'relative', width: 127, height: 127, transform: (insertedRoundAudiosHoveredId === item.id || item.playing) ? 'scale(200/120)' : 'scale(1)', transformOrigin: 'center center', transition: 'transform 0.2s ease' }} onMouseEnter={() => setInsertedRoundAudiosHoveredId(item.id)} onMouseLeave={() => setInsertedRoundAudiosHoveredId(null)}>
                    <svg width={127} height={127} style={{
                      position: 'absolute', left: 0, top: 0,
                      transform: 'rotate(-90deg)',
                      filter: item.playing
                        ? 'drop-shadow(0 0 8px rgba(16, 185, 129, 0.55))'
                        : 'drop-shadow(0 0 3px rgba(16, 185, 129, 0.25))',
                      transition: 'filter 240ms ease',
                    }}>
                      <defs>
                        <linearGradient id={`arg-${item.id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#059669" />
                          <stop offset="50%" stopColor="#10b981" />
                          <stop offset="100%" stopColor="#22d3ee" />
                        </linearGradient>
                      </defs>
                      <circle cx={63.5} cy={63.5} r={60} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth={3} />
                      <circle
                        cx={63.5} cy={63.5} r={60}
                        fill="none"
                        stroke={`url(#arg-${item.id})`}
                        strokeWidth={5}
                        strokeLinecap="round"
                        strokeDasharray={2 * Math.PI * 60}
                        strokeDashoffset={2 * Math.PI * 60 * (1 - (item.duration > 0 ? item.currentTime / item.duration : 0))}
                      />
                    </svg>
                    <div style={{ position: 'absolute', left: 3.5, top: 3.5, width: 120, height: 120, borderRadius: '50%', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', cursor: 'grab' }} onMouseDown={(e) => { if (e.target.closest('button')) return; e.preventDefault(); audioRoundDidDragRef.current = false; audioRoundDragRef.current = { isDragging: true, startX: e.clientX, startY: e.clientY, startLeft: item.position.x, startTop: item.position.y, insertedId: item.id }; }} onTouchStart={(e) => { if (e.target.closest('button')) return; const t = e.touches[0]; audioRoundDidDragRef.current = false; audioRoundDragRef.current = { isDragging: true, startX: t.clientX, startY: t.clientY, startLeft: item.position.x, startTop: item.position.y, insertedId: item.id }; }}>
                      <audio data-round-id={item.id} src={item.audioUrl} onLoadedMetadata={(e) => { const a = e.target; setInsertedRoundAudios(prev => prev.map(it => it.id === item.id ? { ...it, duration: a.duration || 1 } : it)); }} onPlay={() => setInsertedRoundAudios(prev => prev.map(it => it.id === item.id ? { ...it, playing: true } : it))} onPause={() => setInsertedRoundAudios(prev => prev.map(it => it.id === item.id ? { ...it, playing: false } : it))} onEnded={() => setInsertedRoundAudios(prev => prev.map(it => it.id === item.id ? { ...it, playing: false, currentTime: 0 } : it))} style={{ display: 'none' }} />
                      <div className={`audio-round-waves ${item.playing ? 'playing' : ''}`}>
                        <span className="bar" /><span className="bar" /><span className="bar" /><span className="bar" /><span className="bar" />
                      </div>
                      <div role="button" tabIndex={0} onClick={(e) => { e.stopPropagation(); if (audioRoundDidDragRef.current) return; const aud = e.currentTarget.parentElement.querySelector('audio'); if (aud) { if (aud.paused) aud.play(); else aud.pause(); } }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); const aud = e.currentTarget.parentElement.querySelector('audio'); if (aud) { if (aud.paused) aud.play(); else aud.pause(); } } }} onMouseEnter={() => setInsertedRoundAudios(prev => prev.map(it => it.id === item.id ? { ...it, overlayHovered: true } : it))} onMouseLeave={() => setInsertedRoundAudios(prev => prev.map(it => it.id === item.id ? { ...it, overlayHovered: false } : it))} style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: !item.playing ? 'rgba(0,0,0,0.3)' : (item.overlayHovered ? 'rgba(0,0,0,0.2)' : 'transparent') }}>
                        {!item.playing && <svg width="40" height="40" viewBox="0 0 24 24" fill="rgba(255,255,255,0.95)"><path d="M8 5v14l11-7z" /></svg>}
                        {item.playing && item.overlayHovered && <svg width="28" height="28" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" /></svg>}
                      </div>
                    </div>
                  </div>
                  <button type="button" onClick={() => setInsertedRoundAudios(prev => prev.filter(it => it.id !== item.id))} title="Remove" style={{ marginLeft: -12, marginTop: -4, width: 22, height: 22, borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,0.35)', color: 'rgba(255,255,255,0.85)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, opacity: 0.8 }} aria-label="Remove">
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="currentColor"><path d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" /></svg>
                  </button>
                </div>
              ))}
              {insertedRoundTexts.filter(it => it.containerKey === `homework-${homeworkId}-container-${container.id}`).map((item) => (
                <div key={item.id} style={{ position: 'absolute', left: item.position.x, top: item.position.y, zIndex: 10002, display: 'flex', alignItems: 'flex-start', gap: 0 }}>
                  <div
                    style={{ maxWidth: 280, padding: '10px 12px', background: '#fff', border: '1px solid #e0e0e0', borderRadius: 12, boxShadow: '0 4px 16px rgba(0,0,0,0.12)', cursor: 'grab', borderLeft: '4px solid #5c6bc0' }}
                    onMouseDown={(e) => { if (e.target.closest('button')) return; e.preventDefault(); textRoundDragRef.current = { isDragging: true, startX: e.clientX, startY: e.clientY, startLeft: item.position.x, startTop: item.position.y, insertedId: item.id }; }}
                    onTouchStart={(e) => { if (e.target.closest('button')) return; const t = e.touches[0]; textRoundDragRef.current = { isDragging: true, startX: t.clientX, startY: t.clientY, startLeft: item.position.x, startTop: item.position.y, insertedId: item.id }; }}
                  >
                    <p style={{ margin: 0, fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.4, color: '#333' }}>{item.body}</p>
                  </div>
                  <button type="button" onClick={() => setInsertedRoundTexts(prev => prev.filter(it => it.id !== item.id))} title="Remove" style={{ marginLeft: 0, marginTop: -18, width: 22, height: 22, borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,0.35)', color: 'rgba(255,255,255,0.85)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, opacity: 0.8 }} aria-label="Remove">
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="currentColor"><path d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" /></svg>
                  </button>
                </div>
              ))}
            </div>
            );
          })}
          {/* Кнопка добавления контейнера */}
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button
              onClick={() => addHomeworkContainer(homeworkId)}
              style={{
                background: '#ee5a24',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.background = '#d4451a'}
              onMouseLeave={(e) => e.target.style.background = '#ee5a24'}
            >
              +
            </button>
          </div>
          
          {/* Кнопки отправки / проверки homework */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '12px',
            marginTop: '20px',
            padding: '20px',
            borderTop: '2px solid #f0f0f0'
          }}>
            <button
              type="button"
              onClick={() => handleSendHomework(homeworkId)}
              disabled={sendHomeworkSubmittingId === homeworkId}
              style={{
                background: sendHomeworkSubmittingId === homeworkId ? '#c44d1a' : '#ee5a24',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: sendHomeworkSubmittingId === homeworkId ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                opacity: sendHomeworkSubmittingId === homeworkId ? 0.9 : 1
              }}
              onMouseEnter={(e) => { if (sendHomeworkSubmittingId !== homeworkId) e.target.style.background = '#d4451a'; }}
              onMouseLeave={(e) => { if (sendHomeworkSubmittingId !== homeworkId) e.target.style.background = '#ee5a24'; }}
            >
              {sendHomeworkSubmittingId === homeworkId ? (
                <>
                  <span className="send-homework-spinner" aria-hidden />
                  {isStudent ? 'Submitting…' : 'Sending…'}
                </>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {isStudent
                    ? 'Submit Homework'
                    // status 'pending' means eagerlyCreateHomeworkRow silently
                    // created this row in the background — the student was
                    // never actually told, so it still reads as a first send.
                    : ((homeworkData.status && homeworkData.status !== 'pending') ? 'Update & Resend' : 'Send Homework')}
                </>
              )}
            </button>
            {!isStudent && (homeworkData.status === 'submitted' || homeworkData.status === 'reviewed') && (
              <button
                onClick={homeworkData.status === 'reviewed' ? undefined : () => handleMarkReviewed(homeworkId)}
                disabled={homeworkData.status === 'reviewed'}
                style={{
                  background: homeworkData.status === 'reviewed' ? '#1b5e20' : '#2e7d32',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  cursor: homeworkData.status === 'reviewed' ? 'default' : 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  opacity: homeworkData.status === 'reviewed' ? 1 : 1
                }}
                onMouseEnter={homeworkData.status === 'reviewed' ? undefined : (e) => e.target.style.background = '#1b5e20'}
                onMouseLeave={homeworkData.status === 'reviewed' ? undefined : (e) => e.target.style.background = '#2e7d32'}
                title={homeworkData.status === 'reviewed' ? 'Homework has been reviewed' : 'Mark as reviewed'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {homeworkData.status === 'reviewed' ? 'Reviewed ✓' : 'Reviewed'}
              </button>
            )}
          </div>
        </div>
      );

}
